const ReportOwnerCacheTimeout = 300000;
export class AnalyticsReportsService {
    static $inject = ['MessagingHubService', 'AccountService2', 'CacheService', 'MESSAGINGHUBDOMAIN'];
    constructor(MessagingHubService, AccountService2, CacheService, MESSAGINGHUBDOMAIN) {
        this.MessagingHubService = MessagingHubService;
        this.AccountService2 = AccountService2;
        this.CacheService = CacheService;
        this.MESSAGINGHUBDOMAIN = MESSAGINGHUBDOMAIN;
    }
    async getMany(owner, skip = 0, take = 100) {
        const { items } = await this.MessagingHubService.sendCommand({
            to: `postmaster@analytics.${this.MESSAGINGHUBDOMAIN}`,
            method: 'get',
            uri: `/reports?ownerUser=${encodeURIComponent(owner)}&$skip=${skip}&$take=${take}`,
        });
        const promises = [];
        for (const item of items) {
            const promise = this.CacheService.getOrAdd(`${item.ownerUserIdentity}:account`, () => this.AccountService2.get(encodeURIComponent(item.ownerUserIdentity.split('@')[0])), ReportOwnerCacheTimeout)
                .then(resource => {
                if (resource) {
                    item.owner = { email: resource.email, fullName: resource.fullName, phoneNumber: resource.phoneNumber };
                }
                else {
                    item.owner = { email: decodeURIComponent(item.ownerUserIdentity.split('@')[0]) };
                }
            })
                .catch(e => {
                item.owner = { email: decodeURIComponent(item.ownerUserIdentity.split('@')[0]) };
            });
            promises.push(promise);
        }
        await Promise.all(promises);
        return { reports: items };
    }
    async get(reportId) {
        const report = await this.MessagingHubService.sendCommand({
            to: `postmaster@analytics.${this.MESSAGINGHUBDOMAIN}`,
            method: 'get',
            uri: `/reports/${reportId}`,
        });
        const account = await this.AccountService2.get(encodeURIComponent(report.ownerUserIdentity.split('@')[0]));
        report.owner = { email: account.email, fullName: account.fullName, phoneNumber: account.phoneNumber };
        return report;
    }
    async set(report) {
        const resource = await this.MessagingHubService.sendCommand({
            to: `postmaster@analytics.${this.MESSAGINGHUBDOMAIN}`,
            method: 'set',
            type: 'application/vnd.iris.report+json',
            uri: '/reports',
            resource: report,
        });
        return resource.id;
    }
    async delete(reportId) {
        return await this.MessagingHubService.sendCommand({
            to: `postmaster@analytics.${this.MESSAGINGHUBDOMAIN}`,
            method: 'delete',
            uri: `/reports/${reportId}`,
        });
    }
}
AnalyticsReportsService.$inject = ['MessagingHubService', 'AccountService2', 'CacheService', 'MESSAGINGHUBDOMAIN'];
